// new file called DogPicture.jsx
import { Link } from '@inertiajs/react';
import { Button } from 'antd';
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const DepartmentChoise = () => {
    const {t} = useTranslation()

    return (
        <div className='flex flex-col gap-4 items-center w-full'>
            <Link
            href={route('client.blogs.index')}

            >
                <Button>{t('sidebar.blogs')}</Button>
            </Link>

            <Link
            href={route('client.podcast.index')}
            >
                <Button>{t('sidebar.podcast')}</Button>
            </Link>

            <Link
            href={route('client.appointment.index')}
            >
                <Button>{t('topbar.appintment')}</Button>
            </Link>

        </div>
    );
};

export default DepartmentChoise;